import { images } from "../../constants";

const skill = [
  {
    id: 1,
    name: "HTML",
    image: images.html,
  },
  {
    id: 2,
    name: "CSS",
    image: images.css,
  },
  {
    id: 3,
    name: "JavaScript",
    image: images.javascript,
  },
  {
    id: 4,
    name: "React",
    image: images.react,
  },
  {
    id: 6,
    name: "MySQL",
    image: images.mysql,
  },
  {
    id: 7,
    name: "Git",
    image: images.git,
  },
  {
    id: 8,
    name: "Bootstrap",
    image: images.bootstrap,
  },
  {
    id: 9,
    name: "Sass",
    image: images.sass,
  },
  {
    id: 10,
    name: "Linux",
    image: images.linux,
  },
  {
    id: 11,
    name: "AWS",
    image: images.aws,
  },
  {
    id: 12,
    name: "Ansible",
    image: images.ansible,
  },
  {
    id: 13,
    name: "Jenkins",
    image: images.jenkins,
  },
  {
    id: 14,
    name: "Docker",
    image: images.docker,
  },
  {
    id: 15,
    name: "Kubernetes",
    image: images.kubernetes,
  },
  {
    id: 15,
    name: "Python",
    image: images.python,
  },
];

export { skill };
